import { render, staticRenderFns } from "./NonIndividualAffiliationsEscalations.vue?vue&type=template&id=6ff93c00&scoped=true&"
import script from "./NonIndividualAffiliationsEscalations.vue?vue&type=script&lang=js&"
export * from "./NonIndividualAffiliationsEscalations.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualAffiliationsEscalations.vue?vue&type=style&index=0&id=6ff93c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff93c00",
  null
  
)

export default component.exports